/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Pricing_Processing_LabelInputs */



/**
* | output |
* | --- |
* | "Embed Processing:" |
*
* @param {Embed_Captions_Pricing_Processing_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_pricing_processing_label = /** @type {((inputs?: Embed_Captions_Pricing_Processing_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Pricing_Processing_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Traitement d'incrustation :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einbettungsverarbeitung:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elaborazione incorporata:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обработка встраивания:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Procesamiento de incrustación:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("嵌入式处理：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("埋め込み処理:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एम्बेड प्रोसेसिंग:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Processamento de incorporação:")
	return /** @type {LocalizedString} */ ("Embed Processing:")
});